import http from '@/utils/http' //引入axios
export const getBarcode = data => http.get('/rvm-center/api/barcode', {
    params: data
}) //查找条码
export const updataBarcode = data => http.put('/rvm-center/api/barcode', data) //編輯条码
export const addBarcode = data => http.post('/rvm-center/api/barcode', data) //添加条码
export const deleteBarcode = data => http.delete('/rvm-center/api/barcode', {
    params: data
}) //根据barcodes刪除条码
export const exportBarcode = data => http.get('/rvm-center/api/barcode/excel', {
    params: data,
    responseType: 'blob'
})
// 禁用所有条码
export const forbidBarcode = data => http.get('/rvm-center/api/barcode/disableAll')
// 启用所有条码
export const startBarcode = data => http.get('/rvm-center/api/barcode/enableAll')
// export  const findBarcode = data=>http.get('/api/district/superior',{params:data}) //查找部门
export default {
    getBarcode,
    updataBarcode,
    addBarcode,
    deleteBarcode,
    exportBarcode,
    forbidBarcode,
    startBarcode

    // findBarcode
}